module.exports = __webpack_public_path__ + "img/logo9.b63dd64f.png";